import { memo, useMemo } from 'react';
import { merge } from 'lodash';
import { KeyIcon } from '../../icons';
import { S1, S2, S4 } from '../../theme';
import Avatar, { IAvatarProps } from '../Avatar';
import type { IIconProps } from '../../icons/interfaces';
import Grid from '../Grid';

export interface ILoginAvatarProps extends Omit<IAvatarProps, 'src'> {
  src?: string | null;
  imgWidth?: string | number;
  imgHeight?: string | number;
  fallbackIconWidth?: IIconProps['width'];
  fallbackIconHeight?: IIconProps['height'];
}

const LoginAvatar = (props: ILoginAvatarProps) => {
  const {
    width = 26,
    height = 26,
    src,
    imgWidth = 18,
    imgHeight = 18,
    imgProps: preImgProps,
    fallbackIconWidth = 20,
    fallbackIconHeight = 20,
    ...restAvatarProps
  } = props;

  const imgProps = useMemo(() => merge({}, {
    sx: { width: imgWidth, height: imgHeight },
  }, preImgProps), [preImgProps, imgWidth, imgHeight]);

  const fallbackIcon = useMemo(() => (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      width={width}
      height={height}
      sx={{ backgroundColor: S2 }}
    >
      <KeyIcon width={fallbackIconWidth} height={fallbackIconHeight} color={S4} />
    </Grid>
  ), [width, height, fallbackIconWidth, fallbackIconHeight]);

  if (!src) {
    return (
      <Avatar
        width={width}
        height={height}
        backgroundColor={S2}
        {...restAvatarProps}
      >
        {fallbackIcon}
      </Avatar>
    );
  }

  return (
    <Avatar
      width={width}
      height={height}
      backgroundColor={S1}
      src={src}
      imgProps={imgProps}
      {...restAvatarProps}
    >
      {fallbackIcon}
    </Avatar>
  );
};

export default memo(LoginAvatar);
